
import React, { useEffect } from 'react';
import "../Assets/styles/Services.css"
import ServiceBanShape from "../Assets/Resources/service-ban-shape.png"
import Serviceoneimg from "../Assets/Resources/service-one-1.png"
import RightArrow from "../Assets/Resources/service-right-arrow.svg"
import KeyBenefitsImg from "../Assets/Resources/adobe-benefits-img.png"
import KeyBenefitsImg2 from "../Assets/Resources/adobe-benefits-img-2.png"
import KeyBenefitsImg3 from "../Assets/Resources/adobe-benefits-img-3.png"
import KeyBenefitsImg4 from "../Assets/Resources/adobe-benefits-img-4.png"
import KeyBenefitsImg5 from "../Assets/Resources/adobe-benefits-img-5.png"
import AiDataImage from "../Assets/Resources/ai-data-img.png"
import Logo from "../Assets/Resources/banner-logo.svg";
import Slider from "react-slick";
import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'
import SplitType from 'split-type'
import AOS from "aos";
import "aos/dist/aos.css";
import ServiceStar from "../Assets/Resources/service-star.svg"
import AllPageLoader from '../Components/AllPageLoader';

const Automation = () => {


    const serSettings = {
        infinite: true,
        arrows: false,
        speed: 500,
        autoplay: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1200, // For screens smaller than 1200px
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 992, // For screens smaller than 992px
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 768, // For screens smaller than 768px
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 576, // For screens smaller than 576px
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            }
        ]
    };




    useEffect(() => {
        gsap.registerPlugin(ScrollTrigger);

        const SplitTypes = document.querySelectorAll('.text-reveal-animation');
        SplitTypes.forEach((char) => {
            const text = new SplitType(char, { types: 'chars' });
            gsap.from(text.chars, {
                scrollTrigger: {
                    trigger: char,
                    start: 'top 80%',
                    end: 'top 20%',
                    scrub: true,
                    markers: false
                },
                scaleY: 0,
                y: -20,
                transformOrigin: 'top',
                stagger: 0.05
            });
        });
    }, []);

    useEffect(() => {
        const SplitTypes = document.querySelectorAll('.ban-title-animation');
        SplitTypes.forEach((char) => {
            const text = new SplitType(char, { types: 'chars' });
            gsap.from(text.chars, {
                opacity: 0.2,
                stagger: 0.08,
                scrub: true,
            });
        });
    }, []);



    useEffect(() => {
        const SplitTypes = document.querySelectorAll('.mini-title-animation');
        SplitTypes.forEach((char) => {
            const text = new SplitType(char, { types: 'chars' });
            gsap.from(text.chars, {
                scrollTrigger: {
                    trigger: char,
                    start: 'top 80%',
                    end: 'top 20%',
                    scrub: true,
                    markers: false
                },
                opacity: 0.2,
                stagger: 0.08,
                scrub: true,
            });
        });
    }, []);


    useEffect(() => {
        gsap.registerPlugin(ScrollTrigger);

        const elements = document.querySelectorAll('.para-animation');
        elements.forEach((element) => {
            gsap.fromTo(
                element,
                { opacity: 0, y: 20 }, // Start with opacity 0 and slightly below the position
                {
                    opacity: 1,        // End with opacity 1 (fully visible)
                    y: 0,              // Move to the original position
                    duration: 1,       // Adjust duration for smoother transition
                    ease: "power2.out", // Smooth easing
                    scrollTrigger: {
                        trigger: element,
                        start: "top 80%",
                        end: "top 20%",
                        scrub: true,    // One-time animation on scroll
                        markers: false,
                    },
                }
            );
        });
    }, []);



    useEffect(() => {
        gsap.registerPlugin(ScrollTrigger);

        const SplitTypes = document.querySelectorAll('.text-reveal-animation');
        SplitTypes.forEach((char) => {
            const text = new SplitType(char, { types: 'chars' });
            gsap.from(text.chars, {
                scrollTrigger: {
                    trigger: char,
                    start: 'top 80%',
                    end: 'top 20%',
                    scrub: true,
                    markers: false
                },
                scaleY: 0,
                y: -20,
                transformOrigin: 'top',
                stagger: 0.05
            });
        });
    }, []);

    useEffect(() => {
        const SplitTypes = document.querySelectorAll('.ban-title-animation');
        SplitTypes.forEach((char) => {
            const text = new SplitType(char, { types: 'chars' });
            gsap.from(text.chars, {
                opacity: 0.2,
                stagger: 0.08,
                scrub: true,
            });
        });
    }, []);



    useEffect(() => {
        const SplitTypes = document.querySelectorAll('.mini-title-animation');
        SplitTypes.forEach((char) => {
            const text = new SplitType(char, { types: 'chars' });
            gsap.from(text.chars, {
                scrollTrigger: {
                    trigger: char,
                    start: 'top 80%',
                    end: 'top 20%',
                    scrub: true,
                    markers: false
                },
                opacity: 0.2,
                stagger: 0.08,
                scrub: true,
            });
        });
    }, []);


    useEffect(() => {
        gsap.registerPlugin(ScrollTrigger);

        const elements = document.querySelectorAll('.para-animation');
        elements.forEach((element) => {
            gsap.fromTo(
                element,
                { opacity: 0, y: 20 }, // Start with opacity 0 and slightly below the position
                {
                    opacity: 1,        // End with opacity 1 (fully visible)
                    y: 0,              // Move to the original position
                    duration: 1,       // Adjust duration for smoother transition
                    ease: "power2.out", // Smooth easing
                    scrollTrigger: {
                        trigger: element,
                        start: "top 80%",
                        end: "top 20%",
                        scrub: true,    // One-time animation on scroll
                        markers: false,
                    },
                }
            );
        });
    }, []);







    return (
        <>
            <AllPageLoader />
            <section className='service-hero-section'>
                <div className="container-fluid common-btn">
                    <div className="row">
                        <div className="banner-content">
                            <h1 className='ban-title-animation'>Prophecy <br />Technologies</h1>
                            <h6 data-aos="fade-down" data-aos-duration="2000" data-aos-delay="500">Automate Your Success: Streamline Processes with Us!</h6>
                            <p data-aos="fade-down" data-aos-duration="2000" data-aos-delay="700">Boost your operational efficiency and unlock new levels of productivity with our tailored
                                automation solutions. By streamlining processes, we empower your team to focus on
                                strategic initiatives rather than mundane tasks.</p>
                            <a href="/contact">
                                <button data-aos="fade-up" data-aos-duration="2000" data-aos-delay="900">Talk with Our Experts</button>
                            </a>
                        </div>
                    </div>
                </div>
                <div className="service-hero-shape">
                    <img src={ServiceBanShape} alt="" />
                </div>
            </section>


            <section className='service-section-one  sec-padding smarteerTomorrow service-sec'>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-7">
                            <div className="content large-title">
                                <h6 data-aos="fade-right" data-aos-duration="2000" data-aos-delay="300">Achieve Seamless Success: </h6>
                                <h1 className='mini-title-animation'>Simplify Your <br />Operations <br />with Us!</h1>
                                <p className='para-animation'>Achieve seamless success with Prophecy Technologies, where automation transforms
                                    your operations into an efficient, streamlined powerhouse. Our advanced solutions
                                    simplify workflows, reduce manual effort, and eliminate errors, allowing your team to
                                    focus on high-impact tasks. By automating routine processes, we help your business
                                    maximize productivity and reach new levels of operational efficiency.
                                </p>
                                <p className='para-animation'>At Prophecy Technologies, we design automation that adapts to your unique business
                                    needs, integrating seamlessly with your existing systems. Our user-friendly platforms
                                    ensure a smooth transition, minimizing disruptions and accelerating your path to
                                    success. Let us handle the complexities of automation, so you can focus on driving
                                    growth and innovation effortlessly</p>
                                <a href="/contact" className='common-btn service-large-btn'>
                                    <button data-aos="fade-up" data-aos-duration="2000" data-aos-delay="900">Get Started With Us Now!</button>
                                </a>
                            </div>
                        </div>
                        <div className="col-lg-5">
                            <div className="image" data-aos="fade-left" data-aos-duration="2000" data-aos-delay="300">
                                <img src={AiDataImage} alt="" />
                            </div>
                        </div>
                    </div>
                </div>
            </section>



            <div className="gradient-bg">
                <section className='service-section-three gradient-bg sec-padding'>
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-7">
                                <div className="title">
                                    <h6 data-aos="fade-right" data-aos-duration="2000" data-aos-delay="300">How can automation </h6>
                                    <h1 className='mini-title-animation'>Enhance your <br />business <br />efficiency?
                                    </h1>
                                </div>
                            </div>
                            <div className="col-lg-5">
                                <div className="image" data-aos="fade-left" data-aos-duration="2000" >
                                    <img src={KeyBenefitsImg} alt="" />
                                </div>
                            </div>
                        </div>
                        <p className='para-animation'>Automation can transform your business efficiency, enabling higher productivity and
                            streamlined operations effortlessly
                        </p>
                        <div className="benefit-items">
                            <div className="row">
                                <Slider  {...serSettings} className='serSlideItems'>
                                    <div className='serSlide'>
                                        <div className="item" data-aos="fade-up" data-aos-duration="2000" >
                                            <div className="icon">
                                                <img src={ServiceStar} alt="" />
                                            </div>
                                            <div className="content">
                                                <h6>1. Reduce Manual Errors
                                                </h6>
                                                <p>Automating repetitive tasks minimizes human error, ensuring consistent, accurate
                                                    results across all operations.</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='serSlide'>
                                        <div className="item" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="300">
                                            <div className="icon">
                                                <img src={ServiceStar} alt="" />
                                            </div>
                                            <div className="content">
                                                <h6>2.Accelerate Task Completion</h6>
                                                <p>Automation speeds up routine tasks, allowing teams to focus on strategic work,
                                                    improving overall productivity and project timelines.</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='serSlide'>
                                        <div className="item" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="500">
                                            <div className="icon">
                                                <img src={ServiceStar} alt="" />
                                            </div>
                                            <div className="content">
                                                <h6>3. Enhance Customer Experience</h6>
                                                <p>Automation improves response times and accuracy, leading to faster service and
                                                    enhanced customer satisfaction.</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='serSlide'>
                                        <div className="item" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="500">
                                            <div className="icon">
                                                <img src={ServiceStar} alt="" />
                                            </div>
                                            <div className="content">
                                                <h6>4. Increase Data Accuracy</h6>
                                                <p>Automated processes ensure real-time data collection and organization, reducing errors
                                                    and supporting better decision-making.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='serSlide'>
                                        <div className="item" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="500">
                                            <div className="icon">
                                                <img src={ServiceStar} alt="" />
                                            </div>
                                            <div className="content">
                                                <h6>5. Enable Scalability</h6>
                                                <p>Automated workflows are easily scalable, allowing your business to handle increased
                                                    demand without compromising on quality</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='serSlide'>
                                        <div className="item" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="500">
                                            <div className="icon">
                                                <img src={ServiceStar} alt="" />
                                            </div>
                                            <div className="content">
                                                <h6>6. Improve Compliance and Security</h6>
                                                <p>Automated systems can consistently enforce policies and regulatory requirements,
                                                    reducing risks associated with compliance and security. </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='serSlide'>
                                        <div className="item" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="500">
                                            <div className="icon">
                                                <img src={ServiceStar} alt="" />
                                            </div>
                                            <div className="content">
                                                <h6>7. Minimize Operational Costs</h6>
                                                <p>By reducing manual labour and errors, automation lowers costs, maximizing your return
                                                    on investment and boosting profitability.</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='serSlide'>
                                        <div className="item" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="500">
                                            <div className="icon">
                                                <img src={ServiceStar} alt="" />
                                            </div>
                                            <div className="content">
                                                <h6>8. Enhance Communication and Collaboration</h6>
                                                <p>Automated tools streamline communication, ensuring all team members stay informed
                                                    and aligned, fostering collaboration.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </Slider>
                                <p className='para-animation'>At Prophecy Technologies, automation is your gateway to a more efficient,
                                    cost-effective, and agile business</p>
                            </div>
                        </div>
                    </div>
                    <div className="gradient-bg-radial-1"></div>
                    <div className="gradient-bg-radial-2"></div>
                </section>
            </div>


            <section className='service-section-three no-gradient-bg sec-padding'>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-5">
                            <div className="image" data-aos="fade-right" data-aos-duration="2000" data-aos-delay="500">
                                <img src={KeyBenefitsImg2} alt="" />
                            </div>
                        </div>
                        <div className="col-lg-7">
                            <div className="title">
                                <h6 data-aos="fade-left" data-aos-duration="2000" data-aos-delay="500">How does our approach to Automation</h6>
                                <h1 className='mini-title-animation'>Differ from <br />other service<br />
                                    providers?</h1>
                            </div>
                        </div>
                    </div>
                    <p className='para-animation'>Our unique approach to automation at Prophecy Technologies delivers unparalleled
                        value through customization, innovation, and seamless integration.</p>
                    <div className="benefit-items">
                        <div className="row">
                            <Slider  {...serSettings} className='serSlideItems'>
                                <div className='serSlide'>
                                    <div className="item" data-aos="fade-up" data-aos-duration="2000" >
                                        <div className="icon">
                                            <img src={ServiceStar} alt="" />
                                        </div>
                                        <div className="content">
                                            <h6>1. Tailored Solutions for Every Business</h6>
                                            <p>We recognize that every business is unique, offering custom solutions designed
                                                specifically to meet your company’s individual needs.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div className='serSlide'>
                                    <div className="item" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="300">
                                        <div className="icon">
                                            <img src={ServiceStar} alt="" />
                                        </div>
                                        <div className="content">
                                            <h6>2. End-to-End Integration</h6>
                                            <p>Our automation solutions are built to integrate smoothly with your existing systems,
                                                creating a unified and cohesive workflow.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div className='serSlide'>
                                    <div className="item" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="500">
                                        <div className="icon">
                                            <img src={ServiceStar} alt="" />
                                        </div>
                                        <div className="content">
                                            <h6>3. Focus on User-Centric Design</h6>
                                            <p>We prioritize usability, ensuring our automation tools are intuitive and easy for your team
                                                to adopt without extensive training.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div className='serSlide'>
                                    <div className="item" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="500">
                                        <div className="icon">
                                            <img src={ServiceStar} alt="" />
                                        </div>
                                        <div className="content">
                                            <h6>4. Emphasis on Security and Compliance</h6>
                                            <p>Prophecy Technologies builds automation with robust security features and regulatory
                                                compliance, keeping your data and operations safe</p>
                                        </div>
                                    </div>
                                </div>
                                <div className='serSlide'>
                                    <div className="item" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="500">
                                        <div className="icon">
                                            <img src={ServiceStar} alt="" />
                                        </div>
                                        <div className="content">
                                            <h6>5. Collaborative Development Process</h6>
                                            <p>We work closely with you at every step, ensuring that our solutions align perfectly with
                                                your objectives and feedback</p>
                                        </div>
                                    </div>
                                </div>
                                <div className='serSlide'>
                                    <div className="item" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="500">
                                        <div className="icon">
                                            <img src={ServiceStar} alt="" />
                                        </div>
                                        <div className="content">
                                            <h6>6. Innovative, Future-Proof Technology
                                            </h6>
                                            <p>Our automation services utilize cutting-edge technology to keep your business ahead of
                                                trends and prepared for the future.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div className='serSlide'>
                                    <div className="item" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="500">
                                        <div className="icon">
                                            <img src={ServiceStar} alt="" />
                                        </div>
                                        <div className="content">
                                            <h6>7. Transparent Support and Training</h6>
                                            <p>We offer comprehensive support and training, empowering your team to maximize the
                                                benefits of automation with confidence.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div className='serSlide'>
                                    <div className="item" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="500">
                                        <div className="icon">
                                            <img src={ServiceStar} alt="" />
                                        </div>
                                        <div className="content">
                                            <h6>8. Data-Driven Optimizations</h6>
                                            <p>We use data insights to continuously refine and enhance our automation tools, ensuring
                                                ongoing improvement in efficiency.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </Slider>
                            <p className='para-animation'>Prophecy Technologies stands out by offering automation that is not only powerful but
                                tailored, secure, and built to grow your business.</p>
                            <a href="/contact" className='common-btn service-large-btn service-mega-btn'>
                                <button data-aos="fade-up" data-aos-duration="2000" data-aos-delay="900">Take the First Step with Prophecy Now!</button>
                            </a>
                        </div>
                    </div>
                </div>
            </section>



            <div className="gradient-bg">
                <section className='service-section-three gradient-bg sec-padding'>
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-7">
                                <div className="title">
                                    <h6 data-aos="fade-down" data-aos-duration="2000" data-aos-delay="300">How can automation enhance</h6>
                                    <h1 className='mini-title-animation'> customer <br />experience & <br />satisfaction?</h1>
                                </div>
                            </div>
                            <div className="col-lg-5">
                                <div className="image" data-aos="fade-left" data-aos-duration="2000" >
                                    <img src={KeyBenefitsImg3} alt="" />
                                </div>
                            </div>
                        </div>
                        <p className='para-animation'>Automation elevates customer experience and satisfaction by delivering faster,
                            more personalized, and more reliable service.
                        </p>
                        <div className="benefit-items">
                            <div className="row">
                                <Slider  {...serSettings} className='serSlideItems'>
                                    <div className='serSlide'>
                                        <div className="item" data-aos="fade-up" data-aos-duration="2000" >
                                            <div className="icon">
                                                <img src={ServiceStar} alt="" />
                                            </div>
                                            <div className="content">
                                                <h6>1. Quick Response Times</h6>
                                                <p>Automation streamlines response processes, reducing wait times and giving
                                                    customers faster access to support and information.</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='serSlide'>
                                        <div className="item" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="300">
                                            <div className="icon">
                                                <img src={ServiceStar} alt="" />
                                            </div>
                                            <div className="content">
                                                <h6>2. 24/7 Availability</h6>
                                                <p>Automated systems provide round-the-clock support, ensuring customers can
                                                    engage with your business anytime, enhancing convenience.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='serSlide'>
                                        <div className="item" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="500">
                                            <div className="icon">
                                                <img src={ServiceStar} alt="" />
                                            </div>
                                            <div className="content">
                                                <h6>3. Consistent Service Quality</h6>
                                                <p>Automated processes ensure consistent, high-quality interactions, providing
                                                    reliable service across every customer touchpoint.</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='serSlide'>
                                        <div className="item" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="500">
                                            <div className="icon">
                                                <img src={ServiceStar} alt="" />
                                            </div>
                                            <div className="content">
                                                <h6>4. Efficient Issue Resolution</h6>
                                                <p>With automation, repetitive tasks are handled instantly, enabling support teams to
                                                    resolve issues faster and more efficiently.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='serSlide'>
                                        <div className="item" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="500">
                                            <div className="icon">
                                                <img src={ServiceStar} alt="" />
                                            </div>
                                            <div className="content">
                                                <h6>5. Enhanced Self-Service Options</h6>
                                                <p>Automated self-service tools empower customers to find answers independently,
                                                    offering convenience and control over their experience</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='serSlide'>
                                        <div className="item" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="500">
                                            <div className="icon">
                                                <img src={ServiceStar} alt="" />
                                            </div>
                                            <div className="content">
                                                <h6>6. Seamless Omnichannel Experience</h6>
                                                <p>Automation integrates all customer communication channels, ensuring a smooth
                                                    and cohesive experience across platforms.</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='serSlide'>
                                        <div className="item" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="500">
                                            <div className="icon">
                                                <img src={ServiceStar} alt="" />
                                            </div>
                                            <div className="content">
                                                <h6>7. Proactive Customer Engagement</h6>
                                                <p>Automated systems can anticipate customer needs, enabling proactive
                                                    engagement through timely reminders, updates, and support.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='serSlide'>
                                        <div className="item" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="500">
                                            <div className="icon">
                                                <img src={ServiceStar} alt="" />
                                            </div>
                                            <div className="content">
                                                <h6>8. Reduced Human Erro</h6>
                                                <p>Automated interactions are accurate and reliable, minimizing errors that can
                                                    negatively impact customer trust and satisfaction.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </Slider>
                                <p className='para-animation'>At Prophecy Technologies, automation is designed to elevate every customer
                                    interaction, ensuring satisfaction and loyalty at every stage.</p>
                                <a href="/contact" className='common-btn service-large-btn service-mega-btn'>
                                    <button data-aos="fade-up" data-aos-duration="2000" data-aos-delay="900">Contact Us To Get Started
                                    </button>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div className="gradient-bg-radial-1"></div>
                    <div className="gradient-bg-radial-2"></div>
                </section>
            </div>


            <section className='service-section-three no-gradient-bg sec-padding'>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-5">
                            <div className="image" data-aos="fade-right" data-aos-duration="2000" data-aos-delay="500">
                                <img src={KeyBenefitsImg2} alt="" />
                            </div>
                        </div>
                        <div className="col-lg-7">
                            <div className="title">
                                <h6 data-aos="fade-left" data-aos-duration="2000" data-aos-delay="500">How do we customize automation</h6>
                                <h1 className='mini-title-animation'> solutions <br />for unique <br />business
                                    needs?</h1>
                            </div>
                        </div>
                    </div>
                    <p className='para-animation'>At Prophecy Technologies, we create tailored automation solutions that align with your
                        business’s specific goals and requirements.
                    </p>
                    <div className="benefit-items">
                        <div className="row">
                            <Slider  {...serSettings} className='serSlideItems'>
                                <div className='serSlide'>
                                    <div className="item" data-aos="fade-up" data-aos-duration="2000" >
                                        <div className="icon">
                                            <img src={ServiceStar} alt="" />
                                        </div>
                                        <div className="content">
                                            <h6>1. In-Depth Needs Analysis</h6>
                                            <p>We begin by conducting a comprehensive assessment of your business processes to
                                                understand your unique challenges and objectives.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div className='serSlide'>
                                    <div className="item" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="300">
                                        <div className="icon">
                                            <img src={ServiceStar} alt="" />
                                        </div>
                                        <div className="content">
                                            <h6>2. Collaborative Design Process</h6>
                                            <p>Our team works closely with you to co-create automation solutions that are customized
                                                to fit seamlessly into your workflows.</p>
                                        </div>
                                    </div>
                                </div>
                                <div className='serSlide'>
                                    <div className="item" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="500">
                                        <div className="icon">
                                            <img src={ServiceStar} alt="" />
                                        </div>
                                        <div className="content">
                                            <h6>3. Flexible Frameworks</h6>
                                            <p>We use adaptable frameworks that can be modified to accommodate evolving business
                                                needs, ensuring longevity and relevance.</p>
                                        </div>
                                    </div>
                                </div>
                                <div className='serSlide'>
                                    <div className="item" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="500">
                                        <div className="icon">
                                            <img src={ServiceStar} alt="" />
                                        </div>
                                        <div className="content">
                                            <h6>4. Continuous Optimization</h6>
                                            <p>We continuously analyze and optimize your automation processes based on
                                                performance metrics, ensuring maximum efficiency and value.</p>
                                        </div>
                                    </div>
                                </div>
                                <div className='serSlide'>
                                    <div className="item" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="500">
                                        <div className="icon">
                                            <img src={ServiceStar} alt="" />
                                        </div>
                                        <div className="content">
                                            <h6>5. Data-Driven Adjustments</h6>
                                            <p>We use data insights to customize and refine automation processes, adapting them to
                                                meet emerging business needs.
                                            </p>
                                        </div>
                                    </div>
                                </div>

                            </Slider>
                            <p className='para-animation'>With Prophecy Technologies, your automation solution is designed to reflect your
                                unique business needs, delivering a perfect blend of customization and efficiency.</p>
                            <a href="/contact" className='common-btn service-large-btn service-mega-btn'>
                                <button data-aos="fade-up" data-aos-duration="2000" data-aos-delay="900">Schedule a Free Consultation With Us!</button>
                            </a>
                        </div>
                    </div>
                </div>
            </section>




            <section className='cta-section common-btn sec-padding service-page-cta'>
                <div className="container">
                    <div className="row">
                        <div className="sec-title">
                            <div className="large-title">
                                <h6>Streamline for Success:</h6>
                                <h1 className='mini-title-animation'>Let’s Talk About <br />Your <br />Automation Goals!</h1>
                            </div>
                            <p data-aos="fade-up" data-aos-duration="2000">Unlock the power of automation to streamline processes and elevate your
                                business. With our tailored solutions, we’ll help you minimize manual tasks and
                                maximize efficiency. Let’s discuss how automation can accelerate your success
                                today!</p>
                            <a href="/contact" className='common-btn service-large-btn service-mega-btn '>
                                <button data-aos="fade-up" data-aos-duration="2000" data-aos-delay="900">Modernize Your Automation Now!
                                </button>
                            </a>
                        </div>
                    </div>
                </div>
            </section>


        </>
    )
}

export default Automation